import { StubPage } from "@/components/layout/StubPage";

export default function DocsPage() {
  return (
    <StubPage
      title="Documentation"
      description="API, trading guides, and integration docs will ship soon. This space will host developer and institutional resources."
    >
      <p className="text-sm text-slate-600">
        Expect REST + WebSocket references, authentication steps, and example code in
        TypeScript and Python when the docs publish.
      </p>
    </StubPage>
  );
}
